import { DocumentCheckIcon } from '@heroicons/react/24/outline';
import { Switch } from '@main/complykit';
import { useUpdateOrganizationMutation } from '@main/graphql/mutations/UpdateOrganization.admin.generated';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { DrawerProperty } from '@main/ui';

import { useUpdateOrganizationHandler } from './use-update-org-handler';

export const RiskApprovalWorkflowsSwitch = ({ orgId }: { orgId: string }) => {
  const { data } = useGetOrganizationQuery({ orgId });
  const organization = data?.organizations_by_pk;
  const [updateOrganization, { isLoading }] = useUpdateOrganizationMutation();
  const updateOrgHandler = useUpdateOrganizationHandler(orgId);

  if (!organization) {
    return null;
  }

  return (
    <DrawerProperty>
      <DrawerProperty.Label
        icon={DocumentCheckIcon}
        id="risk-approval-workflows-label"
        htmlFor="risk-approval-workflows"
      >
        Risk approval workflows
      </DrawerProperty.Label>
      <DrawerProperty.Content px={2} display="flex" alignItems="center">
        <Switch
          id="risk-approval-workflows"
          aria-labelledby="risk-approval-workflows-label"
          isSelected={organization.is_risk_approval_workflows_enabled}
          isPending={isLoading}
          isDisabled={!organization.is_risks_module_enabled}
          onChange={() => {
            updateOrgHandler(
              updateOrganization({
                organization_id: orgId,
                updatePayload: {
                  is_risk_approval_workflows_enabled:
                    !organization.is_risk_approval_workflows_enabled,
                },
              }),
            );
          }}
        />
      </DrawerProperty.Content>
    </DrawerProperty>
  );
};
